export const translations = {
	appTitle: {
		"fi-FI": "Länsi-Uudenmaan hoivakodit",
		"sv-FI": "Vårdhem i Västra Nyland",
	},
	titleTemplate: {
		"fi-FI": "%s | Länsi-Uudenmaan hoivakodit",
		"sv-FI": "%s | Vårdhem i Västra Nyland",
	},
	navHome: { "fi-FI": "Etusivu", "sv-FI": "Förstasidan" },
	navNursingHomes: { "fi-FI": "Hoivakodit", "sv-FI": "Vårdhem" },
	navInformation: { "fi-FI": "Tiedot", "sv-FI": "Information" },
	menu: { "fi-FI": "valikko", "sv-FI": "meny" },
	linkBacktoTop: {
		"fi-FI": "Sivun alkuun ↑",
		"sv-FI": "Till toppen av sidan ↑",
	},
	linkJumpToContent: {
		"fi-FI": "Hyppää sisältöön",
		"sv-FI": "Hoppa till innehåll",
	},
	jumbotronBtn: { "fi-FI": "Näytä hoivakodit", "sv-FI": "Visa vårdhemmen" },
	jumbotronHeadline: {
		"fi-FI": "Löydä näköisesi hoivakoti",
		"sv-FI": "Hitta ett vårdhem som passar dig",
	},
	locationPickerLabel: {
		"fi-FI": "Miltä alueelta etsit hoivakotia?",
		"sv-FI": "I vilket område söker du ett vårdhem?",
	},
	locationPickerPlaceholder: {
		"fi-FI": "Kaikki alueet",
		"sv-FI": "Alla områden",
	},
	communePickerLabel: {
		"fi-FI": "Mikä on kotikuntasi?",
		"sv-FI": "Vilken är din hemkommun?",
	},
	landingIngress1: {
		"fi-FI":
			"Tältä sivustolta löydät Espoon kaupungin hyväksymät <0>tehostetun palveluasumisen</0> hoivakodit <1>ikäihmisille</1>. Saadaksesi hoivakotipaikan tarvitset Seniorineuvonta Nestorin tekemän myönteisen päätöksen tehostetusta palveluasumisesta.",
		"sv-FI":
			"På denna webbplats hittar du de av Esbo stad godkända vårdhemmen som erbjuder <0>serviceboende med heldygnsomsorg för äldre</0>. För att få en vårdhemsplats behöver du ett positivt beslut av seniorrådgivningen Nestor om serviceboende med heldygnsomsorg. ",
	},
	landingServiceVoucher1: {
		"fi-FI": "Vaihtoehtoisesti asiakas voi ottaa vastaan ",
		"sv-FI": "Letar du efter ett vårdhem med en ",
	},
	landingServiceVoucher2: {
		"fi-FI": "Palvelusetelihoivakoteja voi katsoa osoitteessa ",
		"sv-FI": "Servicesedelsvårdhem kan ses på adressen ",
	},
	urlServiceVoucher: {
		"fi-FI":
			"https://www.espoo.fi/fi-FI/Seniorit/Seniorien_asuminen/Tehostettu_palveluasuminen",
		"sv-FI": "https://www.esbo.fi/sv-FI/Seniorer/Seniorboende/Vardboende",
	},
	linkServiceVoucher: {
		"fi-FI": "palvelusetelin",
		"sv-FI": "servicesedel",
	},
	urlParastapalvelua: {
		"fi-FI": "https://parastapalvelua.fi",
		"sv-FI": "https://parastapalvelua.fi/sv",
	},
	landingOwnMoney: {
		"fi-FI":
			"Hoivakotiin on mahdollista muuttaa myös itse maksavana asiakkaana, jolloin asiakas sopii palvelun sisällöstä ja kaikista maksuista suoraan hoivakodin kanssa.",
		"sv-FI":
			"Klienten kan också betala själv för vårdhemmet. Då avtalar klienten om innehållet i servicen och alla avgifter direkt med vårdhemmet.",
	},
	whatisNursinghomeHeadline: {
		"fi-FI": "Mitä on tehostettu palveluasuminen?",
		"sv-FI": "Vad är serviceboende med heldygnsomsorg?",
	},
	whatisNursinghomeText: {
		"fi-FI":
			"Tehostettu palveluasuminen on tarkoitettu ikääntyneille, jotka tarvitsevat ympärivuorokautisesti hoivaa ja huolenpitoa, eivätkä voi enää asua omassa kodissaan. Tehostetun palveluasumisen hoivakodissa asiakas saa tarpeidensa mukaista hoivaa ja huolenpitoa elämänsä loppuun saakka. Sosiaali- ja terveydenhuollon ammattilaisia on paikalla hoivakodissa jatkuvasti. Osa hoivakodeista on Espoon kaupungin omia ja osa yksityisten ja kolmannen sektorin toimijoiden omistamia. Asiakas maksaa asumisesta ja palvelusta. Asiakkaan maksut määräytyvät tulojen mukaan ja maksu on sama kaikissa tällä sivustolla esillä olevissa hoivakodeissa.",
		"sv-FI":
			"Serviceboende med heldygnsomsorg är avsett för äldre som behöver vård och omsorg dygnet runt och som inte längre kan bo kvar i sitt eget hem. På vårdhemmet som erbjuder serviceboende med heldygnsomsorg får klienten vård och omsorg efter sina behov till slutet av sitt liv.  I vårdhemmet finns det ständigt yrkesutbildade personer inom social- och hälsovården på plats. En del av vårdhemmen drivs av Esbo stad och en del av privata aktörer och aktörer inom den tredje sektorn. Klienten betalar för boende och service. Klientens avgifter bestäms enligt inkomsterna och avgiften är densamma i alla vårdhem som finns på denna webbplats.",
	},
	decisionStepsHeadline: {
		"fi-FI": "Miten saat tehostetun palveluasumisen päätöksen?",
		"sv-FI": "Hur får jag ett beslut om serviceboende med heldygnsomsorg?",
	},
	decisionStep1Headline: {
		"fi-FI": "1. Yhteydenotto Nestoriin",
		"sv-FI": "1. Kontakta Nestor",
	},
	decisionStep1Text: {
		"fi-FI":
			"Espoon Seniorineuvonta Nestori palvelee arkisin klo 9–15 <0>p. 09 816 33 333</0>",
		"sv-FI":
			"Esbo stads seniorrådgivning Nestor betjänar vardagar kl. 9–15 på <0>tfn 09 816 33 333</0>",
	},
	decisionStep2Headline: {
		"fi-FI": "2. Palvelutarpeen selvittäminen",
		"sv-FI": "2. Utredning av servicebehovet",
	},
	decisionStep2Text: {
		"fi-FI":
			"Nestorin sosiaalityöntekijä tulee luoksesi selvittämään palvelutarpeesi",
		"sv-FI":
			"En socialarbetare vid Nestor kommer hem till dig för att reda ut ditt servicebehov",
	},
	decisionStep3Headline: {
		"fi-FI": "3. Palvelupäätös",
		"sv-FI": "3. Servicebeslut",
	},
	decisionStep3Text: {
		"fi-FI":
			"Myönteisen palvelupäätöksen jälkeen voit alkaa etsimään itsellesi sopivaa hoivakotia",
		"sv-FI":
			"Efter ett positivt servicebeslut kan du börja söka ett vårdhem som passar dig",
	},
	decisionMoreInfo: {
		"fi-FI":
			"Lisätietoa tehostettuun palveluasumiseen hakeutumisesta ja asiakaskriteereistä.",
		"sv-FI":
			"Mer information om hur man söker sig till serviceboende med heldygnsomsorg och om klientkriterierna.",
	},
	urlDecisionMoreInfo: {
		"fi-FI":
			"https://www.espoo.fi/fi-FI/Seniorit/Seniorineuvonta_Nestori/Palvelutarpeen_selvittaminen",
		"sv-FI":
			"https://www.esbo.fi/sv-FI/Seniorer/Seniorradgivning_Nestor/Bedomning_av_servicebehovet",
	},
	selectingHeadline: {
		"fi-FI": "Hoivakodin valinta",
		"sv-FI": "Val av vårdhem",
	},
	selectingText: {
		"fi-FI":
			"<0>Voit valita sellaisen hoivakodin, jossa on vapaita asuntoja. Voit käydä tutustumassa hoivakotiin ennen päätöksen tekemistä. Kerro valinnastasi Seniorineuvonta Nestorin omalle sosiaalityöntekijällesi. Jos sinulle mieluisin hoivakoti on täynnä, valitset asunnon muusta hoivakodista ja voit ilmoittautua Nestoriin haluamasi hoivakodin jonoon. Halutessasi voit vaihtaa hoivakotia kun asunto vapautuu.</0> <1>Osa hoivakodeista on rahoitettu valtion tuella ja niistä käytetään tällä sivustolla nimitystä ARA-kohde. Hoivakotia valitsevalle asiakkaalle ARA-kohde tarkoittaa sitä, että asiakkaan varallisuus ei saa ylittää määrättyjä rajoja. Hoivakodeissa, jotka eivät ole ARA-kohteita, ei ole asiakkaan varallisuutta koskevia rajoituksia.</1>",
		"sv-FI":
			"<0>Du kan välja ett vårdhem där det finns lediga bostäder. Du kan besöka vårdhemmet innan du fattar beslut. Berätta om ditt val för din socialarbetare vid Seniorrådgivningen Nestor. Om det vårdhem du föredrar är fullt, väljer du en bostad i ett annat vårdhem och kan anmäla dig hos Nestor till kön till det vårdhem du föredrar. Om du vill kan du byta vårdhem när en bostad blir ledig i det föredragna vårdhemmet.</0><1>En del av vårdhemmen har finansierats med statligt stöd och för dem används på denna webbplats benämningen ARA-objekt. För en klient som väljer vårdhem innebär ARA-objektet att klientens förmögenhet inte får överskrida vissa gränser. I vårdhem som inte är ARA-objekt finns inga begränsningar för klientens förmögenhet.</1>",
	},
	serviceDescriptionHeadline: {
		"fi-FI": "Mitä hoivakodin palveluun sisältyy?",
		"sv-FI": "Vad ingår i vårdhemmets service?",
	},
	serviceDescriptionText: {
		"fi-FI":
			"<0>Tällä sivustolla olevat hoivakodit ovat sitoutuneet noudattamaan Espoon kaupungin palvelukonseptia, joka määrittää palvelun sisällön ja laadun.</0><1>Asiakas asuu hoivakodissa omassa asunnossaan. Ateriat sisältyvät palveluun. Hoivakodin asiakas elää aktiivista elämää oman jaksamisensa mukaan ja saa henkilökunnalta tarvitsemansa avun. Lisäksi hoivakodit järjestävät asiakkaille monipuolista toimintaa.</1>",
		"sv-FI":
			"<0>Vårdhemmen på denna webbplats har förbundit sig att följa Esbo stads servicekoncept som definierar tjänsternas innehåll och kvalitet.</0><1> Klienten bor på vårdhemmet i en egen bostad. Måltiderna ingår i tjänsten. Vårdhemmets klient lever ett aktivt liv så gott det går och får den hjälp som behövs av personalen. Dessutom ordnar vårdhemmen mångsidig verksamhet för klienterna.</1>",
	},
	serviceDescriptionLink: {
		"fi-FI": "Tutustu palvelukonseptiin",
		"sv-FI": "Kolla in servicekonceptet",
	},
	urlServiceDescription: {
		"fi-FI": "https://www.espoo.fi",
		"sv-FI": "https://espoo.fi/sv-FI",
	},
	faqSectionHeadline: {
		"fi-FI": "Usein kysyttyjä kysymyksiä hoivakodeista",
		"sv-FI": "Frågor och svar",
	},
	faqItem1Headline: {
		"fi-FI": "Millaisia asunnot ovat ja voivatko puolisot asua yhdessä?",
		"sv-FI": "Hurdana är bostäderna och kan partner bo tillsammans?",
	},
	faqItem1Text: {
		"fi-FI":
			"<0>Asiakkaalla on yhden hengen asunto. Asunnossa tai sen välittömässä läheisyydessä on wc ja kylpyhuone. Joissakin hoivakodeissa voi olla yhteisiä wc- ja suihkutiloja.</0><1>Osassa hoivakodeissa on kahden hengen asuntoja. Hoivakotien kahden hengen asunnot on tarkoitettu erityisesti yhdessä asuville puolisoille. Puolisot voivat asua yhdessä myös silloin, jos toinen puolisoista ei ole tehostetun palveluasumisen asiakas. Puolison asumisesta ja siihen liittyvistä maksuista sovitaan suoraan hoivakodin kanssa.</1>",
		"sv-FI":
			"<0>Bostaden är för en person. I bostaden eller i dess omedelbara närhet finns toalett och badrum. En del vårdhem kan ha gemensamma toaletter och duschrum.</0><1>I en del vårdhem finns bostäder för två personer. Bostäderna för två personer är särskilt avsedda för partner som bor tillsammans. Partnerna kan bo tillsammans också om den ena partnern inte är klient i serviceboende med heldygnsomsorg. Om partnerns boende och avgifter avtalas direkt med vårdhemmet.</1>",
	},

	faqItem2Headline: {
		"fi-FI": "Onko asunto kalustettu?",
		"sv-FI": "Är bostaden möblerad?",
	},
	faqItem2Text: {
		"fi-FI":
			"Asunnoissa on sähköisesti säädettävä sänky, patja, vaatekaappi, lukittava säilytystila ja kattovalaisin. Asiakas voi tuoda asuntoon omia kalusteita ja tavaroita.",
		"sv-FI":
			"I bostaden finns en ställbar, elektrisk säng, madrass, klädskåp, låsbart förvaringsutrymme och taklampa. Klienten kan ta med sig egna möbler och saker till bostaden.",
	},
	faqItem3Headline: {
		"fi-FI": "Saako tyynyt, peitot, ja liinavaatteet hoivakodista?",
		"sv-FI": "Får jag kuddar, täcken och sängkläder av vårdhemmet?",
	},
	faqItem3Text: {
		"fi-FI":
			"Tyynyjä, peittoja ja liinavaatteita ei yleensä saa hoivakodista, vaan asiakkaan on tuotava ne itse. Tämä selviää kysymällä hoivakodista.",
		"sv-FI":
			"Kuddar, täcken och sängkläder fås vanligen inte av vårdhemmet, utan klienten måste själv ta med dem. Detta får du veta genom att fråga vårdhemmet.",
	},
	faqItem4Headline: {
		"fi-FI": "Kuka siivoaa asunnon?",
		"sv-FI": "Vem städar bostaden?",
	},
	faqItem4Text: {
		"fi-FI":
			"Asunnon viikoittainen siivous sisältyy palveluun. Lisäksi hoivakodin henkilökunta huolehtii asunnon päivittäisestä siistimisestä. Asiakas voi halutessaan osallistua näihin tehtäviin.",
		"sv-FI":
			"Städning av bostaden en gång i veckan ingår i servicen. Dessutom sörjer vårdhemmets personal för den dagliga städningen av bostaden. Klienten kan om hen så önskar delta i dessa uppgifter.",
	},
	faqItem5Headline: {
		"fi-FI": "Kuka ostaa ja pesee asiakkaan vaatteet?",
		"sv-FI": "Vem köper och tvättar klientens kläder?",
	},
	faqItem5Text: {
		"fi-FI":
			"Asiakas käyttää omia vaatteitaan. Hoivakoti huolehtii asiakkaan vaatteiden pesusta. Asiakas vastaa itse erikoispesuja vaativien vaatteiden ja tekstiilien pesettämisestä ja kustannuksista.",
		"sv-FI":
			"Klienten använder egna kläder. Vårdhemmet sköter tvätten av klientens kläder. Klienten ansvarar själv för tvätten av och tvättkostnaderna för kläder och textilier som kräver specialtvätt.",
	},
	faqItem6Headline: {
		"fi-FI": "Mistä saa lääkkeet?",
		"sv-FI": "Varifrån får jag läkemedel?",
	},
	faqItem6Text: {
		"fi-FI":
			"Asiakas maksaa itse omat lääkkeensä. Asiakkaan lääkkeet toimitetaan apteekista annosjakeluna hoivakotiin. Henkilökunta huolehtii lääkkeiden antamisesta.",
		"sv-FI":
			"Klienten betalar själv sina egna läkemedel. De expedieras från apoteket som dosdispensering till vårdhemmet. Personalen sköter om att klienten tar sina läkemedel.",
	},
	faqItem7Headline: {
		"fi-FI": "Saako asukas hoivakodista tarvitsemansa apuvälineet?",
		"sv-FI": "Får klienten nödvändiga hjälpmedel av vårdhemmet?",
	},
	faqItem7Text: {
		"fi-FI":
			"Henkilökohtaiset apuvälineet asiakas voi lainata maksutta HUS Apuvälinekeskuksesta, joka sijaitsee Espoon sairaalassa. Hoivakoti auttaa asiakasta tarvittaessa apuvälineiden noutamisessa. Mahdolliset apuvälineiden noutokustannukset asiakas maksaa itse. Lisäksi hoivakodissa on muita apuvälineitä. Näitä ovat esimerkiksi nostolaitteet, tukikaiteet, ulkoilupyörätuoli sekä asentohoitoon soveltuvat tyynyt.",
		"sv-FI":
			"Klienten kan avgiftsfritt låna personliga hjälpmedel från HUS hjälpmedelscentral, som är belägen på Esbo sjukhus. Vårdhemmet hjälper klienten vid behov med att hämta hjälpmedlen. Klienten betalar själv eventuella kostnader för hämtning av hjälpmedel. Dessutom finns det hjälpmedel på vårdhemmet. Sådana är till exempel lyftanordningar, stödräcken, rullstol för utomhusbruk samt kuddar som lämpar sig för positionsbehandling.",
	},
	faqItem8Headline: {
		"fi-FI": "Mitä ruokailuja palveluun kuuluu?",
		"sv-FI": "Vilka måltider ingår i tjänsten?",
	},
	faqItem8Text: {
		"fi-FI":
			"Asiakas saa hoivakodissa aamiaisen, lounaan, iltapäiväkahvin/välipalan, päivällisen ja iltapalan. Lounas ja päivällinen ovat lämpimiä aterioita. Asiakas saa yöpalan tarvittaessa. Erityisruokavaliot ja lääkäriin määräämät täydennysravintovalmisteet kuuluvat palveluun ja niistä asiakas ei maksa erikseen.",
		"sv-FI":
			"På vårdhemmet får klienten frukost, lunch, eftermiddagskaffe/mellanmål, middag och kvällsmål. Lunchen och middagen är varma måltider. Klienten får nattmat vid behov. Specialkost och kompletterande näringspreparat som ordinerats av läkaren ingår i tjänsten och klienten betalar inte separat för dem.",
	},
	faqItem9Headline: {
		"fi-FI": "Voivatko läheiset ja omaiset yöpyä asiakkaan luona?",
		"sv-FI": "Kan närstående och anhöriga övernatta hos klienten?",
	},
	faqItem9Text: {
		"fi-FI":
			"Läheiset ja omaiset voivat yöpyä tilapäisesti asiakkaan luona. Yöpymisestä on sovittava hoivakodin kanssa.",
		"sv-FI":
			"Närstående och anhöriga kan tillfälligt övernatta hos klienten. Man måste komma överens om övernattningen med vårdhemmet.",
	},
	faqItem10Headline: {
		"fi-FI": "Miten saattohoito järjestetään?",
		"sv-FI": "Hur ordnas vården i livets slutskede?",
	},
	faqItem10Text: {
		"fi-FI":
			"Asiakkaan saattohoito järjestetään pääsääntöisesti hoivakodissa. Asiakas saa tarvitsemansa hoivan ja kivun lievityksen. Hoivakodin henkilökunta kunnioittaa kuolevan vakaumusta ja huolehtii hänen henkisestä hyvinvoinnistaan.",
		"sv-FI":
			"Klientens vård i livets slutskede ordnas i regel på vårdhemmet. Klienten får behövlig vård och smärtlindring. Vårdhemmets personal respekterar den döende personens övertygelse och sörjer för det psykiska välbefinnandet.",
	},
	filterLabel: {
		"fi-FI": "Rajaa tuloksia:",
		"sv-FI": "Avgränsa resultaten:",
	},
	filterAraLabel: { "fi-FI": "ARA-kohde", "sv-FI": "ARA-objekt" },
	filterAraText: {
		"fi-FI": "Näytä vain ARA-kohteet",
		"sv-FI": "Visa bara ARA-objekten",
	},
	filterAraLabel2: { "fi-FI": "Ei ARA-kohde", "sv-FI": "Inte ARA-objekt" },
	filterAraText2: {
		"fi-FI": "Älä näytä ARA-kohteita",
		"sv-FI": "Visa inte ARA-objekten",
	},
	filterAraDesc1: {
		"fi-FI":
			"ARA-kohde tarkoittaa hoivakotia, jonka asiakkaan varallisuus ei saa ylittää tiettyjä rajoja.",
		"sv-FI":
			"Med ARA-objekt avses ett vårdhem där klientens förmögenhet inte får överskrida vissa gränser.",
	},
	filterAraDesc2: {
		"fi-FI":
			"Ei ARA-kohde tarkoittaa hoivakotia, jossa ei ole asiakkaan varallisuutta koskevia rajoituksia.",
		"sv-FI":
			"Med Inte ARA-objekt avses ett vårdhem där det inte finns några begränsningar för klientens förmögenhet.",
	},
	serviceLanguage: { "fi-FI": "Palvelukieli", "sv-FI": "Servicespråk" },
	serviceLanguageLabel: {
		"fi-FI": "Hoivakodin palvelukieli",
		"sv-FI": "Vårdhemmets servicespråk",
	},
	filterFinnish: { "fi-FI": "Suomi", "sv-FI": "Finska" },
	filterSwedish: { "fi-FI": "Ruotsi", "sv-FI": "Svenska" },
	filterYes: { "fi-FI": "Kyllä", "sv-FI": "Ja" },
	filterNo: { "fi-FI": "Ei", "sv-FI": "Nej" },
	filterARABoth: {
		"fi-FI": "Osittain ARA-kohde",
		"sv-FI": "Delvis ARA-objekt",
	},
	filterLocation: { "fi-FI": "Sijainti", "sv-FI": "Läge" },
	filterLAH: {
		"fi-FI": "Lyhytaikainen asuminen",
		"sv-FI": "Kortvarigt boende",
	},
	filterLAHText: {
		"fi-FI": "Näytä lyhytaikaista asumista tarjoavat hoivakodit.",
		"sv-FI": "Visa de vårdhem som erbjuder kortvarigt boende",
	},
	alsoLAHText: {
		"fi-FI": "Myös lyhytaikaista asumista",
		"sv-FI": "Också kortvarigt boende",
	},
	btnClear: { "fi-FI": "Tyhjennä", "sv-FI": "Rensa" },
	btnSave: { "fi-FI": "Tallenna", "sv-FI": "Spara" },
	btnSelect: { "fi-FI": "Valitse", "sv-FI": "Välj" },
	btnSend: { "fi-FI": "Lähetä", "sv-FI": "Skicka" },
	summaryLabel: { "fi-FI": "hoivakotia", "sv-FI": "vårdhem" },
	loadingText: { "fi-FI": "Ladataan...", "sv-FI": "Laddar..." },
	numApartments: { "fi-FI": "Asuntojen määrä", "sv-FI": "Antal bostäder" },
	filterSelections: { "fi-FI": "valintaa", "sv-FI": "val" },
	linkBacktoList: {
		"fi-FI": "Takaisin hoivakotilistaukseen",
		"sv-FI": "tillbaka till listan över vårdhem",
	},
	linkBacktoListShort: {
		"fi-FI": "Takaisin listaukseen",
		"sv-FI": "Tillbaka till listan",
	},
	linkToPublicPage: {
		"fi-FI": "Siirry hoivakodin sivulle",
		"sv-FI": "Gå till vårdhemmets sida",
	},
	anchorDetailsBox: {
		"fi-FI": ">> Hoivakodin yhteystiedot",
		"sv-FI": ">> Kontaktuppgifter",
	},
	basicInformation: { "fi-FI": "Perustiedot", "sv-FI": "Basuppgifter" },
	owner: { "fi-FI": "Omistaja", "sv-FI": "Ägare" },
	yearofConst: { "fi-FI": "Rakennusvuosi", "sv-FI": "Byggnadsår" },
	apartmentSize: {
		"fi-FI": "Asuntojen neliömäärä",
		"sv-FI": "Bostädernas yta",
	},
	apartmentFurnitureLabel: {
		"fi-FI": "Peruskalustus",
		"sv-FI": "Basmöblering",
	},
	apartmentFurnitureText: {
		"fi-FI":
			"Asunnoissa on sähköisesti säädettävä sänky, patja, vaatekaappi, lukittava säilytystila ja kattovalaisin. Asiakas voi tuoda asuntoon omia kalusteita ja tavaroita.",
		"sv-FI":
			"I bostaden finns en ställbar, elektrisk säng, madrass, klädskåp, låsbart förvaringsutrymme och taklampa. Klienten kan ta med sig egna möbler och saker till bostaden.",
	},
	rent: { "fi-FI": "Vuokran määrä", "sv-FI": "Hyra" },
	checkRentWithNursingHome: {
		"fi-FI": "Tarkista vuokran määrä hoivakodista. Vuokran määrä on noin",
		"sv-FI": "Kontrollera hyran hos vårdhemmet. Hyran uppgår till ca",
	},
	LAHapartments: {
		"fi-FI": "Lyhytaikaisen asumisen asuntoja",
		"sv-FI": "Bostäder för kortvarigt boende",
	},
	foodHeader: { "fi-FI": "Ruoka", "sv-FI": "Mat" },
	cookingMethod: {
		"fi-FI": "Ruoan valmistuksen tapa",
		"sv-FI": "Sättet att tillreda mat",
	},
	ownKitchen: { "fi-FI": "Oma keittiö", "sv-FI": "Eget tillredningskök" },
	foodMoreInfo: {
		"fi-FI": "Lisätietoa ruoasta",
		"sv-FI": "Mer information om maten",
	},
	linkMenu: { "fi-FI": "Ruokalista", "sv-FI": "Matlista" },
	activies: { "fi-FI": "Toiminta", "sv-FI": "Aktiviteter" },
	outdoorActivies: {
		"fi-FI": "Ulkoilu\u00admahdollisuudet",
		"sv-FI": "Friluftsmöjligheter",
	},
	visitingInfo: {
		"fi-FI": "Hoivakotiin tutustuminen",
		"sv-FI": "Bekanta dig med vårdhemmet",
	},
	accessibility: { "fi-FI": "Esteettömyys", "sv-FI": "Tillgänglighet" },
	personnel: { "fi-FI": "Henkilökunta", "sv-FI": "Personal" },
	otherServices: {
		"fi-FI": "Muut hoivakodin palvelut",
		"sv-FI": "Vårdhemmets övriga tjänster",
	},
	nearbyServices: {
		"fi-FI": "Lähellä olevat palvelut",
		"sv-FI": "Närliggande tjänster ",
	},
	contactInfo: { "fi-FI": "Yhteystiedot", "sv-FI": "Kontaktuppgifter" },
	directions: { "fi-FI": "Kulkuyhteydet", "sv-FI": "Trafikförbindelser" },
	webpage: {
		"fi-FI": "Hoivakodin verkkosivut",
		"sv-FI": "Vårdhemmets webbplats",
	},
	linkMoreInfoOutdoor: {
		"fi-FI": "Lisätietoa ulkoilumahdollisuuksista",
		"sv-FI": "Läs mera om friluftsmöjligheter",
	},
	linkMoreInfoActivies: {
		"fi-FI": "Lisätietoa toiminnasta",
		"sv-FI": "Läs mera om aktiviteter",
	},
	linkMoreInfoPersonnel: {
		"fi-FI": "Lisätietoa henkilöstön tyytyväisyydestä",
		"sv-FI": "Läs mera om personnel",
	},
	monthShort: { "fi-FI": "kk", "sv-FI": "mm" },
	pageAccessibilityHeader: {
		"fi-FI": "Saavutettavuusseloste",
		"sv-FI": "Tillgänglighetsutlåtande",
	},
	pageAccessibilityBody: {
		"fi-FI":
			"\n\t\t<p>\n\t\t\tTämä saavutettavuusseloste koskee hoivakodit.luvn.fi -sivustoa. Saavutettavuusseloste on päivitetty 7.12.2022. Tämän digipalvelun saavutettavuuden on arvioinut palvelun kehitystiimi.\n\t\t</p>\n\t\t<p>\n\t\t\t<strong>\n\t\t\tDigipalvelun saavutettavuuden tila\n\t\t</strong>\n\t\t\t: Täyttää kriittiset saavutettavuusvaatimukset\n\t\t</p>\n\t\t<p>\n\t\t\tVerkkosivusto ei ole vielä kaikilta osin vaatimusten mukainen.\n\t\t</p>\n\t\t<h3>\n\t\t\tSaavutettavuusvaatimukset jotka eivät täyty\n\t\t</h3>\n\t\t<p>\n\t\t\t2.1.2 Ei näppäimistöansaa – Näppäimistöllä navigoitaessa rajauskomponentti ei toimi kaikkien hyvien käytäntöjen mukaisesti ja fokus ei siirry takaisin lähtöpaikkaan rajausta tallennettaessa.\n\t\t</p>\n\t\t<p>\n\t\t\t3.1.2 Osien kieli – Hoivakotien esittelytekstit ja valvontaraportit ovat pääsääntöisesti vain yhdellä kielellä\n\t\t</p>\n\t\t<h3>\n\t\t\tHuomasitko saavutettavuuspuutteen digipalvelussamme?\n\t\t</h3>\n\t\t<p>\n\t\t\tKerro se meille ja teemme parhaamme puutteen korjaamiseksi.\n\t\t</p>\n\t\t<p>\n\t\t<a href='https://easiointi.espoo.fi/eFeedback/fi/Home' target='_blank' rel='nofollow'>Anna saavutettavuuspalautetta verkkolomakkeella</a> \n\t\t</p>\n\t\t<h3>\n\t\t\tValvontaviranomainen\n\t\t</h3>\n\t\t<p>\n\t\t\tJos huomaat sivustolla saavutettavuusongelmia, anna ensin palautetta meille eli sivuston ylläpitäjälle. Vastauksessa voi mennä 14 päivää. Jos et ole tyytyväinen saamaasi vastaukseen tai et saa vastausta lainkaan kahden viikon aikana, <a href='https://www.saavutettavuusvaatimukset.fi/oikeutesi/' target='_blank' rel='noopener noreferrer external'>voit tehdä ilmoituksen Etelä-Suomen aluehallintovirastoon</a>. Etelä-Suomen aluehallintoviraston sivulla kerrotaan tarkasti, miten ilmoituksen voi tehdä ja miten asia käsitellään.\n\t\t</p>\n\t\t<h4>Valvontaviranomaisen yhteystiedot\n\t\t</h4>\n\t\t<p>\n\t\t\tEtelä-Suomen aluehallintovirasto<br>Saavutettavuuden valvonnan yksikkö<br><a href='https://www.saavutettavuusvaatimukset.fi' target='_blank' rel='noopener noreferrer external'>www.saavutettavuusvaatimukset.fi</a><br><a href='mailto:saavutettavuus@avi.fi'>saavutettavuus@avi.fi</a><br>puhelinnumero vaihde 0295 016 000<br> \n\t\t</p>",
		"sv-FI":
			"\n\t\t<p>\n\t\t\tDetta tillgänglighetsutlåtande gäller webbplatsen hoivakodit.luvn.fi. Tillgänglighetsutlåtandet har uppdaterats 7.12.2022. Teamet som utvecklat denna digitala tjänst har utvärderat dess tillgänglighet.\n\t\t</p>\n\t\t<p>\n\t\t\t<strong>\n\t\t\tTillgänglighetsstatus för den digitala tjänsten\n\t\t</strong>\n\t\t\t: Uppfyller de kritiska tillgänglighetskraven\n\t\t</p>\n\t\t<p>\n\t\t\tWebbplatsen uppfyller ännu inte alla krav.\n\t\t</p>\n\t\t<h3>\n\t\t\tTillgänglighetskrav som inte uppfylls\n\t\t</h3>\n\t\t<p>\n\t\t\t2.1.2 Ingen tangentbordsfälla – Vid navigering med ett tangentbord fungerar inte avgränsningskomponenten enligt all god praxis och fokus överförs inte tillbaka till startplatsen när avgränsningen sparas.\n\t\t</p>\n\t\t<p>\n\t\t\t3.1.2 Språk för del av sida – Vårdhemmens presentationer och tillsynsrapporter finns i regel bara på ett språk.\n\t\t</p>\n\t\t<h3>\n\t\t\tUpptäckte du en tillgänglighetsbrist i vår digitala tjänst?\n\t\t</h3>\n\t\t<p>\n\t\t\tBeskriv den för oss och vi ska göra vårt bästa för att åtgärda den.\n\t\t</p>\n\t\t<p>\n\t\t<a href='https://easiointi.espoo.fi/eFeedback/sv/Home' target='_blank' rel='nofollow'>Ge tillgänglighetsrespons på detta webbformulär</a> \n\t\t</p>\n\t\t<h3>\n\t\t\tTillsynsmyndighet\n\t\t</h3>\n\t\t<p>\n\t\t\tOm du upptäcker problem i tillgängligheten på webbplatsen, ge först respons till oss som ansvarar för webbplatsen. Det kan ta 14 dagar innan du får ett svar. Om du inte är nöjd med det svar du har fått eller inte får något svar alls inom två veckor kan du, <a href='https://www.tillgänglighetskrav.fi/dina-rattigheter/' target='_blank' rel='noopener noreferrer external'>lämna in en anmälan till Regionförvaltningsverket i Södra Finland</a>. På regionförvaltningsverkets webbplats beskrivs det noggrant hur du kan lämna in en anmälan och hur ärendet behandlas.\n\t\t</p>\n\t\t<h4>Tillsynsmyndighetens kontaktuppgifter\n\t\t</h4>\n\t\t<p>\n\t\t\tRegionförvaltningsverket i Södra Finland<br>Enheten för tillgänglighetstillsyn<br><a href='www.tillgänglighetskrav.fi' target='_blank' rel='noopener noreferrer external'>www.tillgänglighetskrav.fi</a><br><a href='mailto:webbtillganglighet@rfv.fi'>webbtillganglighet@rfv.fi</a><br>telefonnummer: växeln 0295 016 000<br> \n\t\t</p>",
	},
	footerLinkPrivacy: {
		"fi-FI": "Tietosuojaseloste",
		"sv-FI": "Dataskyddsbeskrivning",
	},
	footerLinkAccessibility: {
		"fi-FI": "Saavutettavuusseloste",
		"sv-FI": "Tillgänglighetsutlåtande",
	},
	footerLinkFeedback: {
		"fi-FI": "Anna palautetta sivustosta",
		"sv-FI": "Ge respons på webbplatsen",
	},
	vacancyTrue: {
		"fi-FI": "Vapaita pitkäaikaisasuntoja",
		"sv-FI": "Lediga långvariga bostäder",
	},
	vacancyFalse: {
		"fi-FI": "Ei vapaita pitkäaikaisasuntoja",
		"sv-FI": "Inga lediga långvariga bostäder",
	},
	pageUpdateTitle: {
		"fi-FI": "Hoivakodin vapaat asunnot ja kuvat",
		"sv-FI": "Bilder och lediga bostäder",
	},
	freeApartmentsStatus: {
		"fi-FI": "Vapaiden asuntojen tilanne",
		"sv-FI": "Lediga bostäder",
	},
	selectVancyStatus: {
		"fi-FI": "Valitse hoivakodin vapaiden asuntojen tilanne",
		"sv-FI": "Välj situationen för lediga bostäder på vårdhemmet",
	},
	organizationLogo: {
		"fi-FI": "Organisaation / Hoivakodin omistajan logo",
		"sv-FI": "Logotyp för organisationen/vårdhemmets ägare",
	},
	organizationPhotos: {
		"fi-FI": "Hoivakodin valokuvat",
		"sv-FI": "Fotografier från vårdhemmet",
	},
	organizationPhotosGuide: {
		"fi-FI":
			"Laita erilaisia kuvia ulko- ja sisäpuolelta (esimerkiksi sisäänkäynti, piha-alue, oleskelutilat, ruokailutilat, asunto ja kylpyhuone). Ensimmäisessä kuvapaikassa oleva kuva näkyy hoivakotilistauksessa. Kaikki kuvat näkyvät hoivakodin sivulla. Kuvien maksimikoko on 4Mt ja kuvatekstien pituus korkeintaan 200 merkkiä.",
		"sv-FI":
			"Lägg ut olika bilder som är tagna utomhus och inomhus (t.ex. ingång, gårdsplan, vistelserum, matsal, bostad och badrum). Om du lägger ut bilder på människor, kom ihåg att be om tillstånd. Bilden på den första bildplatsen syns i listan över vårdhem. Alla bilder syns på vårdhemmets sida. ",
	},
	emptyImageSpot: {
		"fi-FI": "Tyhjä kuvapaikka",
		"sv-FI": "Tom bildplats",
	},
	swapImage: {
		"fi-FI": "Vaihda kuva",
		"sv-FI": "Byt bild",
	},
	imageUploadTooltip: {
		"fi-FI": "Valitse kuva",
		"sv-FI": "Välj bilden",
	},
	warningImageToLarge: {
		"fi-FI": "Kuvien tulee olla kooltaan alle 4Mt",
		"sv-FI": "Bilderna kan inte vara större än 4Mb",
	},
	organizationLogoBtn: {
		"fi-FI": "Lisää tai päivitä logo",
		"sv-FI": "Lägg till eller uppdatera logotypen",
	},
	cancelPageTitle: {
		"fi-FI": "Peruutit muutokset",
		"sv-FI": "Du ångrade ändringarna",
	},
	backToEdit: {
		"fi-FI": "Palaa muokkaamaan",
		"sv-FI": "Redigera",
	},
	uploadPlaceholder: {
		"fi-FI": "Lisää kuvateksti kirjoittamalla tähän.",
		"sv-FI": "Lägg till en bildtext genom att skriva här.",
	},
	cancelPageContent: {
		"fi-FI":
			"Voit halutessasi palata edelliselle sivulle muokkaamaan tai sulkea tämän sivun.",
		"sv-FI":
			"Om du vill kan du gå tillbaka till föregående sida för att redigera eller stänga sidan.",
	},
	clearFilters: {
		"fi-FI": "Poista rajaukset",
		"sv-FI": "Rensa filter",
	},
	btnShowImages: {
		"fi-FI": "Katso kuvat",
		"sv-FI": "Se bilderna",
	},
	pageUploadReportTitle: {
		"fi-FI": "Lisää uusi käynti",
		"sv-FI": "Lägg till ett nytt besök",
	},
	reportTypeAnnounced: {
		"fi-FI": "Ennalta ilmoitettu käynti",
		"sv-FI": "Förhandsanmält besök",
	},
	reportTypeUnannounced: {
		"fi-FI": "Ennalta ilmoittamaton käynti",
		"sv-FI": "Oanmält besök",
	},
	reportTypeConcern: {
		"fi-FI": "Palautteen perusteella tehty käynti",
		"sv-FI": "Besök på basis av respons",
	},
	selectFile: {
		"fi-FI": "Valitse tiedosto",
		"sv-FI": "Välj fil",
	},
	reportFailed: {
		"fi-FI": "Täytä kaikki kentät ja yritä uudelleen",
		"sv-FI": "Skriv i alla fält och försök på nytt",
	},
	surveyOption1: {
		"fi-FI": "Erittäin huono",
		"sv-FI": "Mycket dålig",
	},
	surveyOption2: {
		"fi-FI": "Huono",
		"sv-FI": "Dålig",
	},
	surveyOption3: {
		"fi-FI": "Tyydyttävä",
		"sv-FI": "Nöjaktig",
	},
	surveyOption4: {
		"fi-FI": "Hyvä",
		"sv-FI": "God",
	},
	surveyOption5: {
		"fi-FI": "Erinomainen",
		"sv-FI": "Utmärkt",
	},
	espoo: {
		"fi-FI": "Espoo",
		"sv-FI": "Esbo",
	},
	esbo: {
		"fi-FI": "Espoo",
		"sv-FI": "Esbo",
	},
	"espoon keskus": {
		"fi-FI": "Espoon keskus",
		"sv-FI": "Esbo centrum",
	},
	espoonlahti: {
		"fi-FI": "Espoonlahti",
		"sv-FI": "Esboviken",
	},
	leppävaara: {
		"fi-FI": "Leppävaara",
		"sv-FI": "Alberga",
	},
	matinkylä: {
		"fi-FI": "Matinkylä",
		"sv-FI": "Mattby",
	},
	tapiola: {
		"fi-FI": "Tapiola",
		"sv-FI": "Hagalund",
	},
	hanko: {
		"fi-FI": "Hanko",
		"sv-FI": "Hangö",
	},
	helsinki: {
		"fi-FI": "Helsinki",
		"sv-FI": "Helsingfors",
	},
	hyvinkää: {
		"fi-FI": "Hyvinkää",
		"sv-FI": "Hyvinge",
	},
	järvenpää: {
		"fi-FI": "Järvenpää",
		"sv-FI": "Träskända",
	},
	karjaa: {
		"fi-FI": "Karjaa",
		"sv-FI": "Karis",
	},
	karis: {
		"fi-FI": "Karjaa",
		"sv-FI": "Karis",
	},
	karkkila: {
		"fi-FI": "Karkkila",
		"sv-FI": "Högfors",
	},
	kerava: {
		"fi-FI": "Kerava",
		"sv-FI": "Kervo",
	},
	kirkkonummi: {
		"fi-FI": "Kirkkonummi",
		"sv-FI": "Kyrkslätt",
	},
	lohja: {
		"fi-FI": "Lohja",
		"sv-FI": "Lojo",
	},
	nurmijärvi: {
		"fi-FI": "Nurmijärvi",
		"sv-FI": "Nurmijärvi",
	},
	raasepori: {
		"fi-FI": "Raasepori",
		"sv-FI": "Raseborg",
	},
	sipoo: {
		"fi-FI": "Sipoo",
		"sv-FI": "Sibbo",
	},
	siuntio: {
		"fi-FI": "Siuntio",
		"sv-FI": "Sjundeå",
	},
	tammisaari: {
		"fi-FI": "Tammisaari",
		"sv-FI": "Ekenäs",
	},
	tuusula: {
		"fi-FI": "Tuusula",
		"sv-FI": "Tusby",
	},
	vantaa: {
		"fi-FI": "Vantaa",
		"sv-FI": "Vanda",
	},
	vihti: {
		"fi-FI": "Vihti",
		"sv-FI": "Vichtis",
	},
	inkoo: {
		"fi-FI": "Inkoo",
		"sv-FI": "Ingå",
	},
	kauniainen: {
		"fi-FI": "Kauniainen",
		"sv-FI": "Grankulla",
	},
	karviainen: {
		"fi-FI": "Karviainen",
		"sv-FI": "Karviainen",
	},
	imageCarouselNextTitle: {
		"fi-FI": "Seuraava (oikea nuoli)",
		"sv-FI": "Nästa (högerpil)",
	},
	imageCarouselPrevTitle: {
		"fi-FI": "Edellinen (vasen nuoli)",
		"sv-FI": "Föregående (Vänsterpil)",
	},
	imageCarouselAltText: {
		"fi-FI": "Kuva",
		"sv-FI": "Bild",
	},
	imageCarouselCloseText: {
		"fi-FI": "Sulje (esc)",
		"sv-FI": "Stäng (esc)",
	},
	nursingHome: {
		"fi-FI": "Hoivakoti",
		"sv-FI": "Vårdhem",
	},
	status: {
		"fi-FI": "Tilanne",
		"sv-FI": "Status",
	},
	lastUpdate: {
		"fi-FI": "Viimeksi päivitetty",
		"sv-FI": "Senast uppdaterad",
	},
	noUpdate: {
		"fi-FI": "Ei päivitetty",
		"sv-FI": "Inte uppdaterad",
	},
	error404Title: {
		"fi-FI": "Hups! Etsimääsi sivua ei löytynyt.",
		"sv-FI": "Sidan du letade efter kan inte hittas",
	},
	errorGeneralTitle: {
		"fi-FI": "Palvelussa on häiriö.",
		"sv-FI": "Systemfel",
	},
	error404Text: {
		"fi-FI":
			"Luultavasti etsimäsi sivun osoite on muuttunut tai sivua ei ole enää olemassa.",
		"sv-FI":
			"Adressen på sidan du letar efter har antagligen ändrats eller finns inte längre.",
	},
	errorGeneralText: {
		"fi-FI": "Yritä myöhemmin uudelleen.",
		"sv-FI": "Försök igen senare.",
	},
	backToFrontPage: {
		"fi-FI": "Palaa etusivulle",
		"sv-FI": "Tillbaka till förstasidan",
	},
	saving: {
		"fi-FI": "Tallennetaan...",
		"sv-FI": "Sparar...",
	},
	cancel: {
		"fi-FI": "Peruuta",
		"sv-FI": "Ångra",
	},
	remove: {
		"fi-FI": "Poista",
		"sv-FI": "Ta bort",
	},
	saved: {
		"fi-FI": "Muutokset tallennettu.",
		"sv-FI": "Data har sparats.",
	},
	Suomi: {
		"fi-FI": "Suomi",
		"sv-FI": "Finska",
	},
	Ruotsi: {
		"fi-FI": "Ruotsi",
		"sv-FI": "Svenska",
	},
	status_ok: {
		"fi-FI": "Erinomainen",
		"sv-FI": "Utmärkt",
	},
	status_small_issues: {
		"fi-FI": "Hyvä",
		"sv-FI": "God",
	},
	status_significant_issues: {
		"fi-FI": "Tyydyttävä",
		"sv-FI": "Nöjaktig",
	},
	status_surveillance: {
		"fi-FI": "Tehostetussa valvonnassa",
		"sv-FI": "Under effektiviserad tillsyn",
	},
	status_waiting: {
		"fi-FI": "Valvontakäynnin tiedot tulossa",
		"sv-FI": "Information över tillsynsbesöket är på väg",
	},
	status_no_info: {
		"fi-FI": "Sijaintikunta valvoo. Valvontakäynnin tietoja ei saatavilla.",
		"sv-FI":
			"Kommunen där vårdhemmet är beläget sköter tillsynen. Uppgifter saknas.",
	},
	status_ok_long: {
		"fi-FI":
			"Erinomainen: Toiminta on lain vaatimusten ja sopimuksen mukaista.",
		"sv-FI":
			"Utmärkt: Verksamheten är förenlig med lagens krav och avtalet.",
	},
	status_small_issues_long: {
		"fi-FI":
			"Hyvä: Toiminnassa on pientä parannettavaa, joka ei kuitenkaan heikennä asiakkaiden hoivan tai turvallisuuden toteutumista.",
		"sv-FI":
			"God: Det finns små brister i verksamheten som bör avhjälpas, men de försvagar dock inte klienternas omsorg eller säkerhet.",
	},
	status_significant_issues_long: {
		"fi-FI":
			"Tyydyttävä: Toiminnassa puutteita, jotka palveluntuottajan tulee korjata annetussa määräajassa laadukkaan hoivan toteuttamiseksi.",
		"sv-FI":
			"Nöjaktig: det finns brister i verksamheten som tjänsteproducenten ska avhjälpa inom utsatt tid för att vården ska vara av hög kvalitet.",
	},
	status_surveillance_long: {
		"fi-FI":
			"Tehostetussa valvonnassa: Palveluntuottajan toiminnassa on ilmennyt useita laatupoikkeamia, joiden korjaamista kaupunki valvoo.",
		"sv-FI":
			"Under effektiviserad tillsyn: I tjänsteproducentens verksamhet har det framkommit flera kvalitetsavvikelser. Staden övervakar att dessa avhjälps.",
	},
	reportScore: {
		"fi-FI": "Valvontakäynnin loppuarvio",
		"sv-FI": "Slutrapport över tillsynsbesöket",
	},
	reportScoreHeader: {
		"fi-FI": "Valvontakäynnit",
		"sv-FI": "Tillsynsbesök",
	},
	latestVisit: {
		"fi-FI": "Viimeisin valvontakäynti",
		"sv-FI": "Senaste tillsynsbesök",
	},
	openReport: {
		"fi-FI": "Avaa raportti",
		"sv-FI": "Öppna rapporten",
	},
	giveReview: {
		"fi-FI": "Anna arvio hoivakodista",
		"sv-FI": "Ge en bedömning av vårdhemmet",
	},
	readMore: {
		"fi-FI": "Lue lisää",
		"sv-FI": "Läs mer",
	},
	relativeReviewsBy: {
		"fi-FI": "Omaisten antamat arviot",
		"sv-FI": "Anhörigas bedömningar",
	},
	fromRelatives: {
		"fi-FI": "Palautetta omaisilta",
		"sv-FI": "Respons av anhöriga",
	},
	customerReviewsBy: {
		"fi-FI": "Asiakkaiden antamat arviot",
		"sv-FI": "Bedömningar av klienter",
	},
	nursingHomeReviews: {
		"fi-FI": "Arviot hoivakodista",
		"sv-FI": "Bedömningar av vårdhemmet",
	},
	linkBackToBasicInfo: {
		"fi-FI": "Palaa perustietoihin",
		"sv-FI": "Gå tillbaka till basuppgifterna",
	},
	nReviews: {
		"fi-FI": "arviota",
		"sv-FI": "bedömningar",
	},
	averageReviewScore: {
		"fi-FI": "Arvioiden keskiarvo",
		"sv-FI": "Medelvärde av bedömningarna",
	},
	average: {
		"fi-FI": "Keskiarvo",
		"sv-FI": "Medeltal",
	},
	reviewFooterHeader: {
		"fi-FI": "Miten arviointeja kerätään?",
		"sv-FI": "Hur samlas bedömningar in?",
	},
	reviewFooterPart1: {
		"fi-FI":
			"Omainen voi tehdä arvioinnin kotikunnan antamalla tunnuksella. Portaaliin ei tallenneta arvioinnin tekijän henkilötietoja. Arvio tehdään valitsemalla tyytyväisyyttä kuvaava numeroarvo sekä antamalla vapaata palautetta.",
		"sv-FI":
			"En anhörig kan göra en bedömning genom att logga in med en kod som hemkommunen gett. Personuppgifter om den som gör bedömningen lagras inte i portalen. Bedömningen görs genom att man väljer ett nummervärde som beskriver nöjdheten samt ger fri respons.",
	},
	reviewFooterPart2: {
		"fi-FI":
			"1=erittäin huono, 2=huono, 3=tyydyttävä, 4=hyvä, 5=erinomainen",
		"sv-FI": "1=mycket dålig, 2=dålig, 3=nöjaktig, 4=god, 5=utmärkt",
	},
	reviewFooterPart3: {
		"fi-FI":
			"Tyytyväisyyskyselyn tulokset näytetään vasta kun tuloksia on vähintään viisi.",
		"sv-FI":
			"Resultaten av nöjdhetsenkäten visas när det finns minst fem svar.",
	},
	reviewFooterPart4: {
		"fi-FI":
			"Asiakas ja/tai omainen voi antaa palautetta hoivakodin toiminnasta (esimerkiksi yksittäisistä tilanteista) <a href='https://www.luvn.fi/fi/meilla-asiakkaana/anna-palautetta'>hyvinvointialueen palautepalvelun kautta</a>.",
		"sv-FI":
			"Klienten och/eller en anhörig kan ge respons på vårdhemmets verksamhet (till exempel på enskilda situationer) via <a href='https://www.luvn.fi/sv/kund-hos-oss/kundtjanst/ge-respons'>välfärdsområdes responstjänst</a>.",
	},
	reviewFooterLink: {
		"fi-FI": "Espoon kaupungin palautepalvelun kautta.",
		"sv-FI": "via Esbo stads responstjänst",
	},
	aboutToGiveReview: {
		"fi-FI": "Olet antamassa arviota hoivakodista",
		"sv-FI": "Du håller på att göra en bedömning av vårdhemmet",
	},
	reviewHelpPart1: {
		"fi-FI": "Antamalla arvion autat hoivakotia kehittämään palvelujaan.",
		"sv-FI":
			"Genom att göra en bedömning hjälper du vårdhemmet att utveckla sina tjänster.",
	},
	reviewHelpPart2: {
		"fi-FI": "Vastaaminen kestää noin 2 minuuttia.",
		"sv-FI": "Det tar cirka 2 minuter att svara.",
	},
	reviewHelpPart3: {
		"fi-FI":
			"Kirjoita saamasi tunnus. Tunnus on tarkoitettu vain sinun käyttöösi.",
		"sv-FI": "Skriv koden du fått. Koden är endast avsedd för ditt bruk.",
	},
	code: {
		"fi-FI": "Tunnus",
		"sv-FI": "Kod",
	},
	wrongCode: {
		"fi-FI": "Virheellinen tunnus",
		"sv-FI": "Felaktig kod",
	},
	start: {
		"fi-FI": "Aloita",
		"sv-FI": "Börja",
	},
	thankYouReview: {
		"fi-FI": "Kiitos arviostasi",
		"sv-FI": "Tack för din bedömning",
	},
	backToFrontpage: {
		"fi-FI": "Palaa palvelun etusivulle",
		"sv-FI": "Gå tillbaka till tjänstens första sida",
	},
	feedbackRelativeReview: {
		"fi-FI": "Omaisten arvio",
		"sv-FI": "Anhörigas bedömning",
	},
	feedbackCustomerReview: {
		"fi-FI": "Asiakkaiden arvio",
		"sv-FI": "Bedömning av klienter",
	},
	feedbackNoReviews: {
		"fi-FI": "Ei annettuja arvioita",
		"sv-FI": "Inga bedömningar",
	},
	feedbackReviews: {
		"fi-FI": "arviota",
		"sv-FI": "bedömningar",
	},
	feedbackGreat: {
		"fi-FI": "Erinomainen",
		"sv-FI": "Utmärkt",
	},
	feedbackGood: {
		"fi-FI": "Hyvä",
		"sv-FI": "God",
	},
	feedbackOk: {
		"fi-FI": "Tyydyttävä",
		"sv-FI": "Nöjaktig",
	},
	feedbackBad: {
		"fi-FI": "Huono",
		"sv-FI": "Dålig",
	},
	feedbackVeryBad: {
		"fi-FI": "Erittäin huono",
		"sv-FI": "Mycket dålig",
	},
	feedbackAverage: {
		"fi-FI": "Keskiarvo tulossa",
		"sv-FI": "Medeltalet publiceras inom kort",
	},
	"Suomi|Ruotsi": {
		"fi-FI": "Suomi|Ruotsi",
		"sv-FI": "Svenska/Finska",
	},
	nursingHomeSummary: {
		"fi-FI": "Lyhyt kuvaus hoivakodista",
		"sv-FI": "Kort beskrivning av vårdhemmet",
	},
	buildingInfo: {
		"fi-FI": "Lisätietoja rakennuksesta",
		"sv-FI": "Mer information om byggnaden",
	},
	apartmentCountInfo: {
		"fi-FI": "Lisätietoja asuntojen määrästä",
		"sv-FI": "Mer information om antalet bostäder",
	},
	apartmentsHaveBathroom: {
		"fi-FI": "Kaikissa asunnoissa on oma kylpyhuone",
		"sv-FI": "Alla bostäder har ett eget badrum",
	},
	rentInfo: {
		"fi-FI": "Lisätietoja vuokrasta",
		"sv-FI": "Mer information om hyran",
	},
	languageInfo: {
		"fi-FI": "Lisätietoja palvelukielestä",
		"sv-FI": "Mer information om servicespråket",
	},
	address: {
		"fi-FI": "Katuosoite",
		"sv-FI": "Adress",
	},
	postalCode: {
		"fi-FI": "Postinumero",
		"sv-FI": "Postnummer",
	},
	city: {
		"fi-FI": "Kaupunki",
		"sv-FI": "Stad",
	},
	district: {
		"fi-FI": "Kaupunginosa",
		"sv-FI": "Distrikt",
	},
	arrivalPublicTransit: {
		"fi-FI": "Saapuminen julkisilla kulkuyhteyksillä",
		"sv-FI": "Ankomst med kollektivtrafik",
	},
	arrivalCar: {
		"fi-FI": "Saapuminen autolla",
		"sv-FI": "Ankomst med bil",
	},
	contactName: {
		"fi-FI": "Yhteyshenkilön nimi",
		"sv-FI": "Kontaktpersonens namn",
	},
	contactTitle: {
		"fi-FI": "Yhteyshenkilön titteli",
		"sv-FI": "Kontaktpersonens titel",
	},
	contactPhone: {
		"fi-FI": "Yhteyshenkilön puhelinnumero",
		"sv-FI": "Kontaktpersonens telefonnummer",
	},
	contactEmail: {
		"fi-FI": "Yhteyshenkilön sähköposti",
		"sv-FI": "Kontaktpersonens e-post",
	},
	contactPhoneInfo: {
		"fi-FI": "Lisätietoja yhteyshenkilön puhelinnumerosta",
		"sv-FI": "Mer information om kontaktpersonens telefonnummer",
	},
	fieldIsRequired: {
		"fi-FI": "Kenttä on pakollinen",
		"sv-FI": "Fältet är obligatoriskt",
	},
	formIsInvalid: {
		"fi-FI": "Lomakkeessa on virheitä!",
		"sv-FI": "Det finns fel i formuläret!",
	},
	contactDescription: {
		"fi-FI": "Yhteydenottoihin liittyvä kuvaus",
		"sv-FI": "Beskrivning av kontakterna",
	},
	hasLAHapartments: {
		"fi-FI": "Hoivakodissa on lyhytaikaisen asumisen asuntoja",
		"sv-FI": "Vårdhemmet har bostäder för kortvarigt boende",
	},
	updateNursingHomeTitle: {
		"fi-FI": "Hoivakodin tietojen muokkaaminen",
		"sv-FI": "Redigering av uppgifterna om vårdhemmet",
	},
	ownerOrganisation: {
		"fi-FI": "Organisaatio joka omistaa hoivakodin",
		"sv-FI": "Organisation som äger vårdhemmet",
	},
	numTotalApartments: {
		"fi-FI": "Hoivakodin asuntojen kokonaismäärä",
		"sv-FI": "Det totala antalet bostäder på vårdhemmet",
	},
	accessibilityInfo: {
		"fi-FI": "Tietoja esteettömyydestä",
		"sv-FI": "Information om tillgänglighet",
	},
	nursingHomeName: {
		"fi-FI": "Hoivakodin nimi",
		"sv-FI": "Vårdhemmets namn",
	},
	helperSummary: {
		"fi-FI": "Hoivakodin palvelulupaus.",
		"sv-FI": "Vårdhemmets servicelöfte.",
	},
	partlyARADestination: {
		"fi-FI": "Osa paikoista ARA-talossa",
		"sv-FI": "En del av platserna i ett ARA-hus",
	},
	helperBuildingInfo: {
		"fi-FI":
			"Tässä voit kertoa mahdollisista tehdyistä tai tulossa olevista peruskorjauksista, laajennuksista jne.",
		"sv-FI":
			"Här kan du berätta om eventuella utförda eller kommande ombyggnader, utvidgningar osv.",
	},
	helperApartmentCountInfo: {
		"fi-FI":
			"Tässä voit kertoa esim. minkä kokoisiin ryhmäkoteihin hoivakoti jakaantuu ja kuinka monta asuntoa on per kerros.",
		"sv-FI":
			"Här kan du berätta t.ex. i hur stora grupphem vårdhemmet delas in och hur många bostäder det finns per våning.",
	},
	helperApartmentSize: {
		"fi-FI": "Esim. 18-25.",
		"sv-FI": "T.ex. 18–25.",
	},
	helperRent: {
		"fi-FI": "Esim. 700-800.",
		"sv-FI": "T.ex. 700–800.",
	},
	helperRentInfo: {
		"fi-FI": "Mitä yhteisiä tiloja asiakkaan vuokraan sisältyy.",
		"sv-FI": "Vilka gemensamma lokaler ingår i klientens hyra.",
	},
	helperLanguage: {
		"fi-FI": "Esim. lisätietoa henkilökunnan muusta kielitaidosta.",
		"sv-FI": "T.ex. mer information om personalens övriga språkkunskaper.",
	},
	foodOwnKitchen: {
		"fi-FI": "Oma valmistuskeittiö",
		"sv-FI": "Eget tillredningskök",
	},
	foodDelivered: {
		"fi-FI": "Ruoka toimitetaan muualta (valmiina tai puolivalmiina)",
		"sv-FI": "Maten levereras utifrån (färdig eller halvfärdig)",
	},
	activitiesInfo: {
		"fi-FI": "Kuvaus hoivakodissa järjestettävästä toiminnasta",
		"sv-FI": "Beskrivning av aktiviteter som ordnas på vårdhemmet",
	},
	helperActivitiesLink: {
		"fi-FI":
			"Jos hoivakodin sivuilla on esim. ulkoilukalenteri, laita sen linkki tähän.",
		"sv-FI":
			"Om det på vårdhemmets webbplats finns t.ex. en kalender för utevistelse, lägg dess länk här.",
	},
	helperOutdoorActivities: {
		"fi-FI":
			"Kuvaa hoivakodin ulkoilumahdollisuuksia. Kuvaile esim. miten ulkoilua järjestetään ja miten asiakkaat ulkoilevat.",
		"sv-FI":
			"Beskriv vårdhemmets friluftsmöjligheter Beskriv t.ex. hur utomhusvistelse ordnas och hur klienterna vistas utomhus.",
	},
	helperAccessibilityInfo: {
		"fi-FI":
			"Tähän voit tarvittaessa kirjoittaa esteettömyyttä koskevia lisätietoja.",
		"sv-FI":
			"Här kan du vid behov skriva mer information om tillgängligheten.",
	},
	staffInfo: {
		"fi-FI":
			"Kerro halutessasi henkilöstöstä, sen rakenteesta ja erityisosaamisesta",
		"sv-FI":
			"Berätta, om du vill, om personalen, dess struktur och specialkompetens",
	},
	helperStaffSatisfaction: {
		"fi-FI":
			"Lisää linkki jos hoivakodin sivuilla on tietoa henkilöstön tyytyväisyydestä (kyselyn tulokset tms.).",
		"sv-FI":
			"Lägg till en länk om det på vårdhemmets webbplats finns information om hur nöjd personalen är (enkätresultat osv.).",
	},
	helperOtherServices: {
		"fi-FI":
			"Kuvaa tähän mitä muita palvelukonseptiin kuulumattomia palveluita hoivakodissa on saatavilla. Kerro myös mistä niiden hinnat löytyvät.",
		"sv-FI":
			"Beskriv här vilka andra tjänster man kan få på vårdhemmet som inte ingår i servicekonceptet. Berätta också var man hittar priserna för dem.",
	},
	labelNearbyServices: {
		"fi-FI":
			"Hoivakodin läheltä löytyvät palvelut esim. kauppa, kirjasto, ravintola jne.",
		"sv-FI":
			"Tjänster som ligger i närheten av vårdhemmet, t.ex. butik, bibliotek, restaurang osv.",
	},
	labelAddImages: {
		"fi-FI": "Lisää kuvia",
		"sv-FI": "Lägg till bilder",
	},
	fieldsWithAsteriskAreMandatory: {
		"fi-FI": "Tähdellä * merkityt kentät ovat pakollisia",
		"sv-FI": "Fälten med asterisk * är obligatoriska",
	},
	helperUrl: {
		"fi-FI": "Esim. https://www.example.com.",
		"sv-FI": "T.ex. https://www.example.com.",
	},
	manualSurveyEntryHelpText: {
		"fi-FI":
			"Syötä vastaukset numerona välillä 1-5. Käytä tarvittaessa desimaalierottimena pistettä.",
		"sv-FI":
			"Mata in varje svar som ett nummer mellan 1 och 5. Använd vid behov en punkt som decimalavskiljare.",
	},
	manualSurveyEntryTitle: {
		"fi-FI": "Syötä asiakaskyselyn vastaukset",
		"sv-FI": "Infoga svaren från en klientenkät",
	},
	surveyAnswersTotal: {
		"fi-FI": "Kyselyyn vastaajia yhteensä",
		"sv-FI": "Antal enkätsvar sammanlagt",
	},
	numberOfShort: {
		"fi-FI": "Kpl",
		"sv-FI": "Stycken",
	},
	filterNursingHomeArea: {
		"fi-FI": "Valitse hoivakodin alue",
		"sv-FI": "Välj vårdhemmets område",
	},
	customerCommune: {
		"fi-FI": "Asiakkaan kotikunta",
		"sv-FI": "Klientens hemkommun",
	},
	labelCustomerCommune: {
		"fi-FI":
			"Kunnat, joihin palveluntuottaja on ilmoittautunut ikääntyneiden tehostetun palveluasumisen hankinnassa",
		"sv-FI":
			"Kommuner för vars invånare tjänsteproducenten erbjuder serviceboende med heldygnsomsorg för äldre",
	},
	filterCommune: {
		"fi-FI": "Valitse kotikunta",
		"sv-FI": "Välj hemkommun",
	},
	filterLanguage: {
		"fi-FI": "Valitse hoivakodin kieli",
		"sv-FI": "Välj vårdhemmets språk",
	},
	filterShowARA: {
		"fi-FI": "Valitse, näytetäänkö vain Ara-kohteet",
		"sv-FI": "Välj om endast ARA-objekten ska visas",
	},
	filterShowLah: {
		"fi-FI": "Valitse, näytetäänkö vain lyhyen ajan asumisen kohteet.",
		"sv-FI": "Välj om endast objekten för kortvarigt boende ska visas.",
	},
	selectCommuneLabel: {
		"fi-FI":
			"Haku näyttää kotikuntasi asukkaille palveluita tarjoavat hoivakodit",
		"sv-FI": "Sökningen visar vårdhem för invånare i din hemkommun",
	},
	charactersLeft: {
		"fi-FI": "merkkiä jäljellä",
		"sv-FI": "tecken kvar",
	},
	openFeedbackPlaceholder: {
		"fi-FI": "Voit jättää vapaata palautetta kirjoittamalla tähän...",
		"sv-FI": "Du kan skriva fritt formulerad respons här...",
	},
	noRelativesOpenTextAnswers: {
		"fi-FI": "Ei vielä omaisten antamaa vapaata palautetta.",
		"sv-FI": "Ännu ingen fritt formulerad respons av anhöriga.",
	},
	next: {
		"fi-FI": "Seuraava",
		"sv-FI": "Nästa",
	},
	previous: {
		"fi-FI": "Edellinen",
		"sv-FI": "Föregående",
	},
	filterOpen: {
		"fi-FI": "Avoin",
		"sv-FI": "Öppen",
	},
	filterApproved: {
		"fi-FI": "Hyväksytty",
		"sv-FI": "Godkänd",
	},
	filterRejected: {
		"fi-FI": "Hylätty",
		"sv-FI": "Avslagen",
	},
	labelFeedbackState: {
		"fi-FI": "Palautteen tila",
		"sv-FI": "Responsens status",
	},
	ariaFeedbackState: {
		"fi-FI": "Valitse palautteen tila",
		"sv-FI": "Välj responsens status",
	},
	headingFeedback: {
		"fi-FI": "Palaute",
		"sv-FI": "Respons",
	},
	approveAllOpenFeedback: {
		"fi-FI": "Hyväksy kaikki avoimet",
		"sv-FI": "Godkänn alla öppna",
	},
	approve: {
		"fi-FI": "Hyväksy",
		"sv-FI": "Godkänn",
	},
	reject: {
		"fi-FI": "Hylkää",
		"sv-FI": "Avslå",
	},
	feedbackResponseInfo: {
		"fi-FI":
			"Tällä sivulla voit vastata omaisten palautteisiin. Muista tallentaa vastauksesi. Voit myös muokata jo annettuja palautteita muokkamalla tekstiä ja tallentamalla uudelleen.",
		"sv-FI":
			"På denna sida kan du svara på respons av anhöriga. Kom ihåg att spara ditt svar. Du kan också redigera respons som redan getts genom att redigera texten och spara den på nytt.",
	},
	feedbackForNursingHome: {
		"fi-FI": "Hoivakodin saama palaute",
		"sv-FI": "Respons på vårdhemmet",
	},
	feedbackResponseHeader: {
		"fi-FI": "Hoivakodin vastaus",
		"sv-FI": "Vårdhemmets svar",
	},
	noFeedbackYet: {
		"fi-FI": "Ei vielä palautteita.",
		"sv-FI": "Ingen respons än.",
	},
	espooFeedbackLink: {
		"fi-FI":
			"https://easiointi.espoo.fi/eFeedback/fi/Feedback/21-Senioripalvelut",
		"sv-FI":
			"https://easiointi.espoo.fi/eFeedback/sv/Feedback/21-Senioripalvelut",
	},
	kirkkonummiFeedbackLink: {
		"fi-FI":
			"https://www.kirkkonummi.fi/anna-palautetta-kunnan-palveluista",
		"sv-FI": "https://www.kyrkslatt.fi/ge-respons-om-kommunens-service",
	},
	kauniainenFeedbackLink: {
		"fi-FI":
			"https://www.kauniainen.fi/sosiaali-_ja_terveyspalvelut/ajankohtaista_tietoa/palaute",
		"sv-FI":
			"https://www.kauniainen.fi/sv/social-_och_halsovard/aktuell_information/respons",
	},
	lohjaFeedbackLink: {
		"fi-FI":
			"https://www.lohja.fi/kaupunki-ja-hallinto/asioi-ja-vaikuta/palaute/sosiaali-ja-terveyspalvelut/",
		"sv-FI":
			"https://www.lohja.fi/sv/social-och-halsovardsservice/halso-och-sjukvardstjanster/administration-och-feedback/",
	},
	raaseporiFeedbackLink: {
		"fi-FI":
			"https://player.myzef.com/raasepori/ajax/?eud=162-b6e9dfdk&qsid=882&quid=4874&language=fi&s=tbrl67325lrmgqi1n399qe9tu1",
		"sv-FI":
			"https://player.myzef.com/raasepori/ajax/?eud=162-4fd7d2z3&qsid=882&quid=4874&language=sv&s=tbrl67325lrmgqi1n399qe9tu1",
	},
	hankoFeedbackLink: {
		"fi-FI":
			"https://www.hanko.fi/kaupunki_ja_paatoksenteko/osallistu_ja_vaikuta/palaute",
		"sv-FI":
			"https://www.hanko.fi/sv/staden_och_beslutsfattande/delta_och_paverka/respons",
	},
	karviainenFeedbackLink: {
		"fi-FI": "https://karviainen.fi/asiointi/palaute/",
		"sv-FI": "https://karviainen.fi/asiointi/palaute/",
	},
	inkooFeedbackLink: {
		"fi-FI": "https://www.inkoo.fi/asiointi_ja_lomakkeet/palaute",
		"sv-FI": "https://www.inga.fi/sv/tjanster_och_blanketter/respons",
	},
	siuntioFeedbackLink: {
		"fi-FI": "https://www.siuntio.fi/palaute",
		"sv-FI": "https://www.sjundea.fi/feedback",
	},
	homepageHeading: {
		"fi-FI": "Hoivakotiportaali",
		"sv-FI": "Vårdhemsportal",
	},
	homepageIngress: {
		"fi-FI":
			"Tervetuloa hoivakotiportaaliin! Täällä voit tutustua ikääntyneiden hoivakoteihin Länsi-Uudellamaalla. Mukana ovat kaikki Länsi-Uudenmaan hyvinvointialueen omistamat hoivakodit sekä hyvinvointialueen kilpailuttamat yksityiset ja järjestöjen hoivakodit.",
		"sv-FI":
			"Välkommen till vårdhemsportalen! Här kan du bekanta dig med vårdhem för äldre i Västra Nyland. Här presenteras alla vårdhem som ägs av Västra Nylands välfärdsområde samt vårdhem som ägs av privata och organisationer och som upphandlas av välfärdsområret.",
	},
	homepageAnchor1: {
		"fi-FI": "Seniori-infon yhteystiedot",
		"sv-FI": "Seniorinfos kontaktuppgifter",
	},
	homepageAnchor2: {
		"fi-FI": "Mitä palveluun sisältyy?",
		"sv-FI": "Vad ingår i servicen?",
	},
	homepageAnchor3: {
		"fi-FI": "Usein kysytyt kysymykset",
		"sv-FI": "Frågor och svar",
	},
	whoAreServicesForTitle: {
		"fi-FI": "Kenelle hoivakotien palvelut on tarkoitettu?",
		"sv-FI": "För vem är vårdhemmen avsedda?",
	},
	whoAreServicesForContent: {
		"fi-FI":
			"<0>Hoivakoti on sinulle mahdollinen vaihtoehto silloin, kun tarvitset hoitoa ja huolenpitoa ympäri vuorokauden etkä voi enää asua omassa kodissasi. Hoivakodissa voit asua turvallisesti elämäsi loppuun saakka.</0><1>Viralliselta nimeltään hoivakodeissa tarjottava palvelu on ympärivuorokautista palveluasumista.</1>",
		"sv-FI":
			"<0>Ett vårdhem är ett möjligt alternativ för dig när du behöver vård och omsorg dygnet runt och inte längre kan bo i ett eget hem. I vårdhemmet kan du bo tryggt livet ut.</0><1>Servicen på vårdhemmen kallas officiellt för serviceboende med heldygnsomsorg.</1>",
	},
	howToApplyTitle: {
		"fi-FI":
			"Näin haet hoivakotipaikkaa: ota ensin yhteyttä Seniori-infoon",
		"sv-FI":
			"Så här söker du en vårdhemsplats: kontakta först välfärdsområdet",
	},
	howToApplyDesc: {
		"fi-FI":
			"Kun elämässäsi tulee vaihe, ettet voi enää asua omassa kodissasi:",
		"sv-FI": "När du inte längre kan bo i ett eget hem:",
	},
	howToApplySteps: {
		"fi-FI":
			"<0>Ota yhteyttä ikääntyneiden neuvonta- ja asiakasohjausyksikköön Seniori-infoon (yhteystietomme löydät alta)</0><1>Selvitämme yhdessä sinun ja läheistesi kanssa, millaista palvelua tarvitset.</1><2>Saat meiltä kirjallisen päätöksen palveluista, jotka sinulle on myönnetty.</2>",
		"sv-FI":
			"<0>Kontakta Seniorinfo (rådgivnings- och kundhandledningsenheten) för äldre (du hittar våra kontaktuppgifter nedan)</0><1>Vi utreder tillsammans med dig och dina närstående hurdan service du behöver.</1><2>Vi ger dig ett skriftligt beslut om de tjänster som du har beviljats.</2>",
	},
	contactDesc: {
		"fi-FI": "Yhteystietomme:",
		"sv-FI": "Våra kontaktuppgifter:",
	},

	contactItem: {
		"fi-FI":
			"p. <a href='tel:0291512270' style='white-space: nowrap;'>029 1512 270</a> (puhelun hinta 0,084e/min), s-posti: <a href='mailto:seniori-info@luvn.fi'>seniori-info@luvn.fi</a>",
		"sv-FI":
			"tfn <a href='tel:0291512270' style='white-space: nowrap;'>029 1512 270</a> (samtalets pris 0,084e/min), e-post: <a href='mailto:seniori-info@luvn.fi'>seniori-info@luvn.fi</a>",
	},
	contactAvailability: {
		"fi-FI":
			"Puhelinpalvelu on avoinna arkisin klo 9–15.",
		"sv-FI":
			"Telefonservice är öppen vardagar kl. 9–15.",
	},
	howToPickTitle: {
		"fi-FI": "Myönteisen päätöksen saatuasi",
		"sv-FI": "Efter att du har fått ett positivt beslut",
	},
	howToPickContent1: {
		"fi-FI":
			"Hyvinvointialue järjestää sinulle tarvettasi vastaavan hoivapaikan viimeistään kolme kuukauden kuluessa palvelutarpeen toteamisesta. Osana palvelutarpeen arviota selvitetään toiveesi ja erityistarpeesi. Halutessasi voit esittää yhden toiveen hoivakodista tai hoivakodin sijainnista. Meillä ei ole käytössä jonotusjärjestelmää, vaan tarjoamme paikan hoivakodista asiakkaiden tarpeen mukaisessa järjestyksessä. Saatuasi tiedon sinulle myönnetystä hoivakotipaikasta, sinun tulee olla valmiina muuttamaan vuorokauden kuluessa.",
		"sv-FI":
			"Välfärdsområdet kommer att ordna en vårdplats som motsvarar dina behov senast inom tre månader efter att servicebehovet har fastställts. Som en del av bedömningen av servicebehovet kommer dina önskemål och särskilda behov att undersökas. Om du vill kan du framföra ett önskemål om vårdhem eller vårdhemmets läge. Vi har inget kösystem, utan erbjuder plats på vårdhem i ordning efter klienternas behov. När du har fått information om den beviljade vårdplatsen måste du vara redo att flytta inom ett dygn. ",
	},
	howToPickContent3: {
		"fi-FI":
			"Jos myöhemmin kuitenkin toivot muuttoa toiseen hoivakotiin, voit ilmoittaa toiveestasi hoivapaikan järjestämisestä vastaaville hoitokoordinaattoreille: <a href='mailto:ikaantyneetasuminen@luvn.fi'>ikaantyneetasuminen@luvn.fi</a>. Muuttotoiveesi on voimassa kolme kuukautta.",
		"sv-FI":
			"Om du senare önskar flytta till ett annat vårdhem kan du anmäla ditt önskemål till vårdkoordinatorerna som ansvarar för ordnandet av vårdplatsen: <a href='mailto:ikaantyneetasuminen@luvn.fi'>ikaantyneetasuminen@luvn.fi</a>. Din flyttönskan är giltig i tre månader.",
	},
	howToPickContent4: {
		"fi-FI":
			"Osa hoivakodeista on saanut valtiolta tukea rakentamiseen. Tällaiset hoivakodit olemme merkinneet ARA-kohteiksi. Näissä hoivakodeissa varallisuutesi ei saa ylittää määrättyjä rajoja. Muissa hoivakodeissa ei ole varallisuutta koskevia rajoituksia. <a href='https://www.ara.fi/asukasvalinta'>Lisätietoja asiakasvalinnasta valtion tukemiin vuokra-asuntoihin.</a>.",
		"sv-FI":
			"Vissa vårdhem har fått statligt stöd för byggandet. Sådana vårdhem har vi markerat som ARA-objekt. I dessa vårdhem får din förmögenhet inte överstiga vissa gränser. I andra vårdhem finns det inga förmögenhetsbegränsningar. <a href='https://www.varke.fi/sv/val-av-boende'>Mer information om kundval till statligt stödda hyresbostäder.</a>",
	},
	whatServicesIncludesTitle: {
		"fi-FI": "Mitä hoivakotien palveluun sisältyy?",
		"sv-FI": "Vad ingår i vårdhemmens service?",
	},
	whatServicesIncludesContent1: {
		"fi-FI":
			"Kaikki Hoivakotiportaalissa esiteltävät hoivakodit noudattavat Länsi-Uudenmaankuntien yhteisiä periaatteita palvelun sisällöstä ja laadusta. <0>Lue lisää palvelukonseptista</0>.",
		"sv-FI":
			"Alla vårdhem som presenteras i Vårdhemsportalen följer Västra Nylands kommuners gemensamma principer för servicens innehåll och kvalitet. <0>Läs mer om servicekonceptet</0>.",
	},
	whatServicesIncludesContent2: {
		"fi-FI":
			"Hoivakodissa on jatkuvasti paikalla henkilökuntaa, joka antaa tarvitsemasi avun ja varmistaa, että saat tarvittavan terveyden- ja sairaanhoidon.",
		"sv-FI":
			"På vårdhemmet finns ständigt personal som ger den hjälp som du behöver och säkerställer att du får den hälso- och sjukvård som behövs.",
	},
	whatServicesIncludesContent3: {
		"fi-FI":
			"Henkilökunta varmistaa, että voit elää aktiivista elämää omien toiveidesi ja tottumustesi mukaisesti. Sinulla on mahdollisuus esimerkiksi ulkoiluun, liikkumiseen, kulttuuriin ja harrastamiseen.",
		"sv-FI":
			"Personalen ser till att du kan leva ett aktivt liv enligt dina önskemål och vanor. Du har möjlighet till exempel till friluftsliv, motion, kultur och hobbyer.",
	},
	whatServicesIncludesContent4: {
		"fi-FI":
			"Hoivakodissa asut vuokraamassasi asunnossa. Ateriat sisältyvät palveluun.",
		"sv-FI":
			"I vårdhemmet bor du i en bostad du hyr. Måltiderna ingår i servicen.",
	},
	whatServicesIncludesContent5: {
		"fi-FI": "Voit asua hoivakodissa elämäsi loppuun saakka.",
		"sv-FI": "I vårdhemmet kan du bo livet ut.",
	},
	paymentsTitle: {
		"fi-FI": "Maksut",
		"sv-FI": "Avgifter",
	},
	paymentsContent: {
		"fi-FI":
			"Maksat asiakasmaksun hyvinvointialueelle ja vuokran palveluntuottajalle. Vuokranmaksu alkaa hyvinvointialueen ilmoittamasta muuttopäivästä. Asiakasmaksu määräytyy tulojesi mukaan. Vuokra vähennetään asiakkaan tuloista asiakasmaksua laskettaessa. Lisätietoa asiakasmaksuista <a href='https://www.luvn.fi/fi/meilla-asiakkaana/sosiaali-ja-terveyspalvelujen-asiakasmaksut'>Sosiaali- ja terveyspalvelujen asiakasmaksut | Länsi-Uudenmaan hyvinvointialue</a>",
		"sv-FI":
			"Du betalar en klientavgift till välfärdsområdet och en hyra till vårdhemmet. Klientavgiften beror på dina inkomster. Även hyran påverkar klientavgiftens belopp. Mer information om klientavgifter: <a href='https://www.luvn.fi/sv/kund-hos-oss/social-och-halsovardens-klientavgifter'>Klientavgifter för social- och hälsovårdstjänster | Västra Nylands välfärdsområde",
	},
	surveillanceTitle: {
		"fi-FI": "Hoivakotien valvonta",
		"sv-FI": "Tillsyn över vårdhem",
	},
	homepageFaqTitle: {
		"fi-FI": "Usein kysyttyjä kysymyksiä",
		"sv-FI": "Frågor och svar",
	},
	faq1Title: {
		"fi-FI": "Millaisia hoivakotien asunnot ovat?",
		"sv-FI": "Hurdana är vårdhemmens bostäder?",
	},
	faq1Content: {
		"fi-FI":
			"<0>Suurin osa asunnoista on yhden hengen asuntoja. Asunnossa tai sen välittömässä läheisyydessä on wc ja kylpyhuone.</0><1>Jokaisessa asunnossa on sähköisesti säädettävä sänky, patja, vaatekaappi, lukittava säilytystila ja kattovalaisin. Voit tuoda asuntoon omia kalusteitasi ja tavaroitasi. Asunnon koko on keskimäärin 21-24 m².</1><2>Lisäksi hoivakodeissa on kodikkaita ja esteettömiä yhteisiä tiloja, joissa voi oleskella ja ruokailla.</2>",
		"sv-FI":
			"<0>Största delen av bostäderna är för en person. I bostaden eller i dess omedelbara närhet finns toalett och badrum.</0><1>I varje bostad finns en ställbar, elektrisk säng, madrass, klädskåp, låsbart förvaringsutrymme och taklampa. Du kan ta med dig egna möbler och saker till bostaden. Lägenhetens storlek är i genomsnitt 21–24 m².</1><2>I vårdhemmen finns dessutom hemtrevliga och tillgänglighetsanpassade gemensamma lokaler där du kan vistas och äta.</2>",
	},
	faq2Title: {
		"fi-FI": "Voinko asua yhdessä puolisoni kanssa?",
		"sv-FI": "Får jag bo tillsammans med min partner?",
	},
	faq2Content: {
		"fi-FI":
			"Joissain hoivakodeissa on kahden hengen asuntoja, jotka on tarkoitettu yhdessä asuville puolisoille. Voit asua yhdessä puolisosi kanssa, vaikka vain toinen teistä olisi hoivakodin asiakas. Puolison kanssa asumisesta ja siihen liittyvistä maksuista tulee sinun sopia suoraan hoivakodin kanssa.",
		"sv-FI":
			"I vissa vårdhem finns bostäder för två personer. De är avsedda för partner som bor tillsammans. Du kan bo tillsammans med din partner, även om bara en av er är klient på vårdhemmet. Om att bo med partnern och därtill hörande avgifter kan du avtala direkt med vårdhemmet.",
	},
	faq3Title: {
		"fi-FI": "Saanko tyynyt, peitot, ja liinavaatteet hoivakodista?",
		"sv-FI": "Får jag kuddar, täcken och sängkläder av vårdhemmet?",
	},
	faq3Content: {
		"fi-FI":
			"Käytännöt tyynyjen, peittojen ja liinavaatteiden osalta vaihtelevat hoivakodeittain. Kysy tarkempia tietoja suoraan hoivakodista muuton yhteydessä.",
		"sv-FI":
			"Riktlinjer för kuddar, täcken och sängkläder varierar mellan olika vårdhem. Fråga vårdhemmet direkt för mer information vid flytten.",
	},
	faq4Title: {
		"fi-FI": "Kuka siivoaa asuntoni?",
		"sv-FI": "Vem städar upp min bostad?",
	},
	faq4Content: {
		"fi-FI":
			"Hoivakoti huolehtii asuntosi viikoittaisesta siivouksesta ja asunnon päivittäisestä siistimisestä. Voit halutessasi osallistua näihin tehtäviin.",
		"sv-FI":
			"Vårdhemmet sköter veckostädningen och den dagliga städningen av din bostad. Du kan delta i dessa uppgifter om du vill.",
	},
	faq5Title: {
		"fi-FI": "Kuka huolehtii vaatteistani?",
		"sv-FI": "Vem sköter mina kläder?",
	},
	faq5Content: {
		"fi-FI":
			"Hoivakodissa jokainen käyttää omia vaatteitaan. Hoivakoti huolehtii vaatteidesi pesemisestä. Tämän vuoksi kaikki vaatteet tulee nimetä tekstiilitussilla tai nimilapuilla. Jos sinulla on erikoispesuja vaativia vaatteita ja tekstiilejä, vastaat itse niiden pesettämisestä ja kustannuksista.",
		"sv-FI":
			"I vårdhemmet använder var och en sina egna kläder. Vårdhemmet sköter tvätten av dina kläder. Om du har kläder och textilier som kräver specialtvätt, ansvarar du själv för tvätten av dem och kostnaderna.",
	},
	faq6Title: {
		"fi-FI": "Mistä saa lääkkeeni?",
		"sv-FI": "Varifrån får jag mina läkemedel?",
	},
	faq6Content: {
		"fi-FI":
			"Asiakas maksaa itse omat lääkkeensä. Hoivakoti avustaa sinua tekemään apteekkisopimuksen ja apteekki toimittaa lääkkeesi hoivakotiin. Hoivakodin henkilökunta huolehtii lääkehoidostasi.",
		"sv-FI":
			"Var och en betalar själv sina egna läkemedel. Vårdhemmet hjälper dig att göra ett avtal med apoteket och apoteket levererar dina läkemedel till vårdhemmet. Vårdhemmets personal tar hand om din läkemedelsbehandling.",
	},
	faq7Title: {
		"fi-FI": "Saanko tarvitsemani apuvälineet hoivakodista?",
		"sv-FI": "Får jag de hjälpmedel jag behöver av vårdhemmet?",
	},
	faq7Content: {
		"fi-FI":
			"Hoivakodeissa on nostolaitteet, tukikaiteet, ulkoilupyörätuoli sekä asentohoitoon soveltuvat tyynyt. Tarvitsemasi henkilökohtaiset apuvälineet saat maksutta lainaksi apuvälinepalveluista. Sinä ja omaisesi vastaatte ensisijaisesti apuvälineiden hankkimisesta ja niiden kuljettamiseen liittyvistä kustannuksista. Tarvittaessa hoivakoti auttaa sinua apuvälinetarpeen kartoittamisessa.",
		"sv-FI":
			"Vårdhemmen har lyftanordningar, stödräcken, rullstol för utomhusbruk samt kuddar som lämpar sig för positionsbehandling. De personliga hjälpmedel du behöver kan du låna gratis från hjälpmedelstjänsterna. Du och dina anhöriga ansvarar främst för att skaffa hjälpmedel och för kostnaderna för deras transport. Vid behov hjälper vårdhemmet dig att kartlägga behovet av hjälpmedel.",
	},
	faq8Title: {
		"fi-FI": "Mitä ruokailuja palveluun kuuluu?",
		"sv-FI": "Vilka måltider ingår i servicen?",
	},
	faq8Content: {
		"fi-FI":
			"Saat hoivakodissa aamiaisen, lounaan, iltapäiväkahvin/välipalan, päivällisen ja iltapalan. Lounas ja päivällinen ovat lämpimiä aterioita. Saat tarvittaessa myös yöpalan. Erityisruokavaliot ja lääkärin määräämät täydennysravintovalmisteet kuuluvat palveluun, niistä sinun ei tarvitse maksaa erikseen.",
		"sv-FI":
			"På vårdhemmet får du frukost, lunch, eftermiddagskaffe/mellanmål, middag och kvällsmål. Lunchen och middagen är varma måltider. Du får också nattmat vid behov. Specialkost och läkarordinerade kompletterande näringspreparat ingår i servicen och du behöver inte betala separat för dem.",
	},
	faq9Title: {
		"fi-FI": "Voivatko läheiset ja omaiset yöpyä luonani?",
		"sv-FI": "Kan närstående och anhöriga övernatta hos mig?",
	},
	faq9Content: {
		"fi-FI":
			"Läheiset ja omaiset voivat tilapäisesti yöpyä luonasi. Sovithan yöpymisestä etukäteen hoivakodin kanssa.",
		"sv-FI":
			"Närstående och anhöriga kan tillfälligt övernatta hos dig. Kom överens om övernattningen på förhand med vårdhemmet.",
	},
	faq10Title: {
		"fi-FI": "Miten tulee toimia, kun asuminen päättyy?",
		"sv-FI": "Hur ska man agera när boendet upphör?",
	},
	faq10Content: {
		"fi-FI":
			"Kun asuminen hoivakodissa päättyy, asunto tulee tyhjentää viipymättä. Näin pystymme parhaiten tarjoamaan palvelua kaikille sitä tarvitseville. Vuokranmaksu päättyy, kun asunto on tyhjä.",
		"sv-FI":
			"När boendet på vårdhemmet upphör, ska bostaden tömmas omedelbart. På så sätt kan vi bäst erbjuda service till alla som behöver det. Hyresbetalningen avslutas när bostaden är tom.",
	},
	changeNursingHomeCommunes: {
		"fi-FI": "Muokkaa hoivakodin kotikuntia",
		"sv-FI": "Redigera hemkommuner",
	},
	surveillanceDescription: {
		"fi-FI":
			"Hyvinvointialue valvoo, että hoivakotien toiminta on sovittujen laatuvaatimusten ja muiden kriteerien mukaista. Siksi teemme hoivakoteihin valvontakäyntejä: osan valvontakäynneistä sovimme hoivakotien kanssa etukäteen ja osan käynneistä teemme ennalta ilmoittamatta. Teemme valvontakäynnin tarvittaessa myös silloin, kun saamme palautteen hoivakotiin liittyvästä huolesta. ",
		"sv-FI":
			"Välfärdsområdet övervakar att vårdhemmen följer kvalitetskraven och andra kriterier. Därför gör vi tillsynsbesök i vårdhemmen: en del av tillsynsbesöken avtalar vi på förhand med vårdhemmen och en del av besöken gör vi utan förhandsanmälan. Vi gör ett tillsynsbesök vid behov också när vi får respons om oro angående vårdhemmet.",
	},
	surveyOpenAnswerInstruction1: {
		"fi-FI":
			"Anna yleistä palautetta hoivakodin laadusta. Palaute julkaistaan kun se on hyväksytty. Palautteen antajan nimi pysyy piilossa. Tietoja joista voidaan tunnistaa henkilö, ei voida julkaista.",
		"sv-FI":
			"Ge allmän respons på vårdhemmets kvalitet. Responsen publiceras när den har godkänts. Responsgivarens namn publiceras inte. Uppgifter som gör det möjligt att identifiera en person kan inte publiceras.",
	},
	surveyOpenAnswerInstruction2: {
		"fi-FI":
			"Jos haluat antaa tietoja jostain tietystä henkilöstä tai tilanteesta tai haluat palautteeseen henkilökohtaisen vastauksen, anna palaute kunnan oman <0>palautekanavan</0> kautta.",
		"sv-FI":
			"Om du vill lämna information om en viss person eller en viss situation eller om du vill ha ett personligt svar på responsen, ge respons via kommunens egen <0>responskanal</0>.",
	},
	linkReadMoreSurveillance: {
		"fi-FI": "Lue lisää valvonnasta",
		"sv-FI": "Läs mer om tillsynen",
	},
};
